// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__349XG","fullView":"styles_fullView__18sUB"};